import { gql } from 'urql';

const SiteFragment = gql`
  fragment SiteFragment on Site {
    id
    coordinates {
      latitude
      longitude
    }
    name
    distance
    networkCode
    networkIconUrl
    networkName
    portsCount
    maxSpeed
    trackingState
    status
    openDate
    includedInReport
    matchingPortsCount
    includedInReportPortsCount
    selectedForReport
    amenities {
      name
      distanceWalkingMeters
      type
      openingHours
    }

    realTimeLocation {
      id
      name
      timezone
      address {
        address
        city
        state
        postalCode
        country
        coordinates { latitude longitude }
      }
      chargingPool {
        id
        lastUpdated
        program
        status
        evses {
          uid
          evseId
          name
          status
          connectors {
            id
            standard
            maxPower
          }
          createdAt
          lastUpdated
          lastSuccessfulCharge
          estimatedWaitTime
          metrics {
            averageChargingTime
            retryRate
            failureRate
            hourlyHistoricalUtilization
            currentUtilization
          }
        }
        reliabilityScore
        currentPricing 
      }
    }
    historicalView {
      portTypes
      hardwareTypes
      pricingModel
      utilizationSeries
    }
  }
`;

export default SiteFragment;
